export const OrderAction = {
    GET_LIST: "get_list",
    GET_NEXT_PAGE_LIST: "get_next_page_list",
    GET_SHIPMENT_DETAIL: "get_shipment_detail",
    UPDATE_ORDER_PRODUCT_STATUS: "update_order_product_status",
}